import { Component, Output, EventEmitter, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { BaseEditComponent } from '@app/cp/shared/base-components/base-edit.component';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { OrderService } from '@app/cp/shared/services/order.service';
import { SaveMode } from '@app/cp/shared/enums/SaveMode';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { BillDetailsComponent } from './bill-details/bill-details.component';
import { OrderBillBus } from '@app/cp/shared/models/OrderBillBus';

@Component({
    selector: 'bills',
    templateUrl: './bills.component.html',
    styleUrls: ['./bills.component.scss']
})
export class BillsComponent extends BaseEditComponent<OrderBillBus, OrderService, null, null> {

    constructor(globals: GlobalsService, qry_rd: DQOIReferenceDataQuery, svc_data: OrderService) {
        super(globals, qry_rd);
        this.svc_data = svc_data;
        this.readOnly = !this.rights.EnterBills; // false;
        this.saveMode = SaveMode.all;
    }
    @ViewChild('LineItems') protected lineItems: BillDetailsComponent;
    @Output() closed: EventEmitter<any> = new EventEmitter<any>();

    gridData: OrderBillBus[];
    orderId: any;

    cancel() {
        this.closed.emit(false);
    }
    getData() {

        this.subs_data = this.svc_data.getBillsForOrder(this.orderId).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                //this.info = new OrderMessageInfo(info);
                ////this.gridData = _.cloneDeep(this.info.orderDetailItems);
                this.gridData = info.primaryReturn as OrderBillBus[];
                //this.gridDataSaved = _.cloneDeep(this.gridData);
                //if (CommonFunctions.hasArrayElementValue(info.orderReceived)) {
                //    let arr = [];
                //    for (let i = 0; i < this.info.orderReceived.length; i++) {
                //        let item: GItem = { description: DateFunctions.formatDate_short(this.info.orderReceived[i].dateReceived), value: this.info.orderReceived[i].orderReceiveId, category: null };
                //        arr.push(item);
                //    }
                //    this.ordersReceivedCBO = arr;
                //}
                ////this.gridData = info.orderDetailItems
                //let busObj: OrderReceiveBus = new OrderReceiveBus(null); //info.primaryReturn);
                //this.setNewObjDefaults(busObj);
                //busObj.orderId = this.orderId;
                //this.setData(busObj);
                ////                this.lineItemsComp.setup(this.gridData);
                //this.edit();
            }
        });

    }
    saveAll() {
        let now: Date = DateFunctions.getDateNow();
        //this.li
        let busObj: OrderBillBus = new OrderBillBus(this.data,false);
        busObj.orderId = this.orderId;
        busObj.setFromForm(this.editForm.value);
        busObj.setCommon(this.globals.userId, now, this.globals.companyId);
        //let orderDetails: OrderDetailsBus[] = this.lineItems.getChanged();
        //if (CommonFunctions.hasArrayElementValue(orderDetails)) {
        //    let arr = [];
        //    for (let i = 0; i < orderDetails.length; i++) {
        //        let busObjDet: OrderReceiveDetailsBus = new OrderReceiveDetailsBus(null);
        //        busObjDet.orderDetailId = orderDetails[i].orderDetailId;
        //        busObjDet.inventoryLocationId = orderDetails[i].inventoryLocationId;
        //        busObjDet.quantityReceived = orderDetails[i].quantityReceived;
        //        busObjDet.inventoryId = orderDetails[i].inventoryId;
        //        busObjDet.supplierId = orderDetails[i].supplierId;
        //        //busObjDet.currentCost = orderDetails[i].ratio
        //        busObjDet.updateCost = false;
        //        busObjDet.setCommon(this.globals.userId, now, this.globals.companyId, this.globals.personId);
        //        arr.push(busObjDet);
        //    }
        //    busObj.orderReceiveDetails = arr;
        //}
        //busObj.orderDetails = this.lineItems.getChanged();
        // busObj.copyData(this.addtlData, this.pageData);
        //busObj.vendorReturnDetails = _.cloneDeep(this.lineItemsComponent.getAll());
        //busObj.deletedItems = _.cloneDeep(this.lineItemsComponent.getDeletedItems());
        //this.svc_data.saveOrderReceiving(busObj).subscribe((info: OrderMessageInfo) => {
        //    if (!info.saveError) {
        //        this.saveSuccess();
        //        this.closed.emit(true);
        //    }
        //    else {
        //        this.saveError(info.message);
        //    }
        //});

    }
    setup(data: any) {

        this.orderId = data;
        //        if (this.hasId) {
        this.getData();
        this.readOnly = false;
        //        }
        //else {
        //    this.new()
        //}
    }
}
